// @flow
import { makeGetRequest } from './utils'

import type { ResponseAPI } from './types/api'
import type { Config } from './types/config'

export const getConfig = (url: string): Promise<ResponseAPI<Config>> => makeGetRequest(url)
